if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('.product-media-modal__content');
        this.lifestyleSource = this.querySelector('#ProductModalLifestyleImages');

        if (this.lifestyleSource) {
          this.lifestyleObserver = new MutationObserver(() => this.syncLifestyleImagesToContent());
          this.lifestyleObserver.observe(this.lifestyleSource, {childList: true});
        }
      }

      show(opener) {
        this.syncLifestyleImagesToContent();
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy?.getAttribute('data-media-id');

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        let activeMedia = null;
        if (activeMediaId) {
          activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        }

        if (!activeMedia && this.content) {
          activeMedia = this.content.querySelector('[data-media-id], img, deferred-media, .product-media-modal__model');
        }

        if (!activeMedia) {
          return;
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.clientWidth - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      syncLifestyleImagesToContent() {
        if (!this.content || !this.lifestyleSource) {
          return;
        }

        this.content.querySelectorAll('[data-from-lifestyle="1"]').forEach((element) => element.remove());

        const sourceItems = Array.from(this.lifestyleSource.children);
        if (!sourceItems.length) {
          return;
        }

        const fragment = document.createDocumentFragment();
        sourceItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-from-lifestyle', '1');
          clone.classList.remove('active');
          fragment.appendChild(clone);
        });

        this.content.appendChild(fragment);
      }

      disconnectedCallback() {
        this.lifestyleObserver?.disconnect();
      }
    }
  );
}
